export const getPostRole = item => {
	if (!item?.user) return 'Super Admin'

	if (item?.hub?.admin && item?.user?._id === item?.hub?.admin) return 'Community Admin'

	if (item?.sanstha?.admin && item?.user?._id === item?.sanstha?.admin) return 'Sanstha Admin'

	return 'User'
}

export const formatDate = date => (date ? new Date(date).toLocaleDateString('en-IN') : '')

export const fullName = p => `${p?.firstName || ''} ${p?.lastName || ''}`.trim()

export const fullAddress = p =>
	`${p?.nativePlaceAddress || ''}, ${p?.nativeArea || ''}, ${p?.nativeBlock ||
		''}, ${p?.nativeDistrict || ''}, ${p?.nativeState || ''}, ${p?.nativePlacePincode || ''}`

export const businessAddress = p =>
	`${p?.businessNativePlaceAddress || ''}, ${p?.businessNativeArea ||
		''}, ${p?.businessNativeBlock || ''}, ${p?.businessNativeDistrict ||
		''}, ${p?.businessNativeState || ''}, ${p?.businessNativePlacePincode || ''}`

export const calculateAgeFromDOB = dob => {
	if (!dob) return ''

	const birthDate = new Date(dob)
	if (isNaN(birthDate)) return ''

	const today = new Date()

	let age = today.getFullYear() - birthDate.getFullYear()
	const monthDiff = today.getMonth() - birthDate.getMonth()

	if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
		age--
	}

	return age
}

export const categoryOptions = [
	{ value: 'Announcement', label: 'Announcement' },
	{ value: 'Inspiration', label: 'Inspiration' },
	{ value: 'Achievement', label: 'Achievement' },
	{ value: 'Activity', label: 'Activity' },
	{ value: 'Photo Update', label: 'Photo Update' },
	{ value: 'Devotional', label: 'Devotional' },
	{ value: 'Awareness', label: 'Awareness' },
]

export const contributionTypes = [
	{ label: 'Membership Subscription', value: 'Membership Subscription' },
	{ label: 'Boli Contributions', value: 'Boli Contributions' },
	{ label: 'Social Project Donations', value: 'Social Project Donations' },
	{ label: 'Voluntary Contribution', value: 'Voluntary Contribution' },
	{ label: 'Sales/Service Collections', value: 'Sales/Service Collections' },
	{ label: 'Facility Booking', value: 'Facility Booking' },
	{ label: 'Sponsorship', value: 'Sponsorship' },
	{ label: 'Premium Membership', value: 'Premium Membership' },
]
